// Returns a random number or element given a range (object with min & max properties or an array).
function Random(range, returnOnInvalid)
{
  if ( range instanceof Array )
  {
    return range[ Math.floor( Math.random() * range.length ) ];
  }
  else if ( typeof range === 'object' )
  {
    return (range.max - range.min) * Math.random() + range.min; 
  }
  return returnOnInvalid;
}